import React from 'react';
import PropTypes from 'prop-types';
import { Nav, NavTab, Badge } from './Navigation.style';

const Navigation = ({ items, isActive, onNavigate, cartCount }) => (
  <Nav>
    {items.map((item) => (
      <NavTab
        key={item.path}
        $active={isActive(item.path)}
        onClick={() => onNavigate(item.path)}
      >
        <i className={`mdi ${item.icon}`} />
        {item.label}
        {item.badge && cartCount > 0 && <Badge>{cartCount}</Badge>}
      </NavTab>
    ))}
  </Nav>
);

Navigation.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
      badge: PropTypes.bool,
    })
  ).isRequired,
  isActive: PropTypes.func.isRequired,
  onNavigate: PropTypes.func.isRequired,
  cartCount: PropTypes.number,
};

export default Navigation;
